

/// <reference path="CommunicationTemplate.ts" />

// Generated class SMSTemplate_ManagedObject

class SMSTemplate_ManagedObject extends CommunicationTemplate
{
}
